import { render, staticRenderFns } from "./provider-employergroupdialog.vue?vue&type=template&id=445b8784&scoped=true"
import script from "./provider-employergroupdialog.vue?vue&type=script&lang=js"
export * from "./provider-employergroupdialog.vue?vue&type=script&lang=js"
import style0 from "./provider-employergroupdialog.vue?vue&type=style&index=0&id=445b8784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b8784",
  null
  
)

export default component.exports